import axios from 'axios';
import Cookies from 'universal-cookie';
import { wt_decode } from './utility';
import { EPC_COOKIES_KEY } from './apiConsts';
import { renewTokenAndSetCookie } from '../store/actions/userData/userData';
const cookies = new Cookies();

const API_PREFIX = '/api';
const BEARER_PREFIX = 'Bearer';
const EPC_USER_REGION = 'epc-region';

const isLocalAPI = apiPath => apiPath.startsWith(API_PREFIX);

export const concatServerNameToAPI = apiPath => {
  const { REACT_APP_SERVER_HOST_NAME } = process.env;

  return isLocalAPI(apiPath)
    ? `${REACT_APP_SERVER_HOST_NAME}${apiPath}`
    : apiPath;
};

const buildAPIPath = (basePath, parameters) => {
  const url = new URL(basePath, window.location.origin);

  if (parameters && Object.keys(parameters).length > 0) {
    const searchParams = new URLSearchParams(parameters);
    url.search = searchParams.toString();
  }

  return url.href;
};

const getValidToken = () => {
  try {
    const token = wt_decode(cookies.get(EPC_COOKIES_KEY));
    return token?.exp * 1000 >= Date.now();
  } catch (err) {
    return false;
  }
};

export const addHeadersIfNeeded = async apiPath => {
  if (!isLocalAPI(apiPath)) return {};

  //   const region = cookies.get(FFC_USER_REGION);
  const token = getValidToken()
    ? cookies.get(EPC_COOKIES_KEY)
    : await renewTokenAndSetCookie();

  return {
    Authorization: `${BEARER_PREFIX} ${token}`,
    // Region: region || '',
    EPC_CLIENT_REQUEST: true,
  };
};

const handleRequestError = (err, apiPath, requestType) => {
  const apiName = apiPath.split('/').pop() || apiPath;

  if (requestType && err.response) {
    store.dispatch(
      setErrorAccordingToType({
        type: requestType,
        desc: err.response.data,
        apiName,
      })
    );
    throw err.response.data;
  } else {
    console.error(err);
  }
};

export const getRequest = async (apiPath, params = {}, config = {}) => {
  try {
    const pathWithParams = buildAPIPath(concatServerNameToAPI(apiPath), params);
    const headers = await addHeadersIfNeeded(apiPath);
    const finalConfig = { headers, ...config };

    const { data } = await axios.get(pathWithParams, finalConfig);

    if (data?.error) {
      throw new Error(data.error);
    }
    return data;
  } catch (error) {
    // handleRequestError(err, apiPath, requestType);
  }
};

export const postRequest = async (apiPath, data, config = {}) => {
  try {
    const headers = await addHeadersIfNeeded(apiPath);
    const finalConfig = { headers, ...config };

    const { data: responseData } = await axios.post(
      concatServerNameToAPI(apiPath),
      data,
      finalConfig
    );

    return responseData;
  } catch (err) {
    // handleRequestError(err, apiPath, requestType);
  }
};

export const patchRequest = async (apiPath, data, config = {}) => {
  try {
    const headers = await addHeadersIfNeeded(apiPath);
    const finalConfig = { headers, ...config };

    const { data: responseData } = await axios.patch(
      concatServerNameToAPI(apiPath),
      data,
      finalConfig
    );

    return responseData;
  } catch (err) {
    // handleRequestError(err, apiPath, requestType);
  }
};

export const putRequest = async (apiPath, data, config = {}) => {
  try {
    const headers = await addHeadersIfNeeded(apiPath);
    const finalConfig = { headers, ...config };

    const { data: responseData } = await axios.put(
      concatServerNameToAPI(apiPath),
      data,
      finalConfig
    );
    return responseData;
  } catch (err) {
    // handleRequestError(err, apiPath, requestType);
  }
};

export const deleteRequest = async (
  apiPath,
  requestType,
  dataObj,
  config = {}
) => {
  try {
    const headers = await addHeadersIfNeeded(apiPath);
    const finalConfig = { headers, ...config, data: dataObj };

    const { data: responseData } = await axios.delete(
      concatServerNameToAPI(apiPath),
      finalConfig
    );
    return responseData;
  } catch (err) {
    // handleRequestError(err, apiPath, requestType);
  }
};
